import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import styles from './BlogPosts.scss'
import whiteBox from '../../scss/WhiteBox.scss'
import {useSliderHook} from '../../hooks/useSliderHook'
import {isInViewPortHook} from '../../hooks/isInViewPortHook'
import {isMobileHook} from '../../hooks/isMobileHook'


export const BlogPost = (props) => {
	const classes = [styles.post];
	if (props.className) {
		classes.push(props.className);
	}
	return (
	  <div className={classes.join(' ')}>
		  <div className={`${whiteBox.container} ${whiteBox.paddingNone}`}>
			  <div className={styles.stepImg} style={{backgroundImage: `url('${props.img}')`}}/>
			  <div className={styles.whiteBoxInner}>
				  <h3>
					  <a
						data-elements-text={props.title}
						data-elements-content={props.analyticsType}
						data-elements-position={props.analyticsPositionIndex}
						href={props.link}
						target={'_blank'}
						rel={'noopener noreferrer'}>
						  <span>{props.title}</span>
					  </a>
				  </h3>
				  <p>{props.description}</p>
			  </div>
		  </div>
	  </div>
	)
}

BlogPost.propTypes = {
	link: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	className: PropTypes.string,
	analyticsPositionIndex: PropTypes.number,
	analyticsType: PropTypes.string,
}

export const BlogPostsContainer = (props) => {
	const {
		sliderRef,
		sliderInitialized,
		animationComplete,
		setAnimationComplete,
		settings,
	} = useSliderHook(props.id, props.id + '_container', 500)

	const isMobile = isMobileHook(500)

	const getSlider = () => {
		return (
		  <Slider {...settings} ref={sliderRef}>
			  {props.children}
		  </Slider>
		)
	}

	if (props.useInitialAnimation) {
		const isInViewPort = isInViewPortHook(props.id, false)
		if (sliderInitialized && isMobile && sliderRef && sliderRef.current && !animationComplete) {
			sliderRef.current.slickGoTo(3, true)
			if (isInViewPort) {
				setTimeout(() => {
					setAnimationComplete(true)
					sliderRef.current.slickGoTo(0)
				}, 1000)
			}
		}
	}
	return (
	  <div id={props.id + '_container'} className={styles.postsContainerOuter}>
		  <div id={props.id} className={styles.container}>
			  {isMobile ? getSlider() : props.children}
		  </div>
	  </div>
	)
}
BlogPostsContainer.defaultProps = {
	useInitialAnimation: true
}

BlogPostsContainer.propTypes = {
	id: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	useInitialAnimation: PropTypes.bool
}

